<!-- TODO(design): placeholder-sheets.svg does not exist; borrowing the Files
     illustration so the empty state is not a broken image. See B-11. -->
<app-list-load-error [error]="loadingError" (retry)="resetItems()" />

@if (items?.length === 0 && !loading && !loadingError) {
  @if (notFoundTemplate) {
    <ng-template [ngTemplateOutlet]="notFoundTemplate" />
  } @else {
    <app-no-content-stub imageSrc="assets/placeholders/empty-sheets.png" [size]="65">
      <p class="text-base font-medium text-gray-900 text-center">{{ (inTrash || inArchive) && narrowed ? NO_MATCH_TITLE : inTrash ? TRASH_EMPTY_TITLE : inArchive ? ARCHIVE_EMPTY_TITLE : 'No folders' }}</p>
    </app-no-content-stub>
  }
}

<div
  #scrollableContainer
  class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16"
  [class.px-8]="isCard()"
  appSelectableList
  #appSelectableList="appSelectableList"
  [appSelectableListLabel]="S['Folders']"
  [deselectOnReclick]="false"
  [appSelectableListReset]="resetSelected"
  [appSelectableListItems]="items"
  (openSelected)="handleOpenSelected($event)">

  @if (loading && (!items || items.length === 0)) {
    <app-loading-indicator [inPanel]="true">Loading folders...</app-loading-indicator>
  }

  @for (item of items; track item.data.id; let index = $index) {
    @if (item.showSectionHeader) {
      <app-list-items-separator
        [value]="item.section"
        [flush]="isCard()"
        [compact]="isCard() && compactCard()"
        [ruled]="isCard() && !$first" />
    }

    <app-sheet-folder
      [item]="item.data"
      [withTags]="withTags"
      [withKnots]="withKnots"
      [position]="index"
      [actionsButtonEnabled]="actionsButtonEnabled()"
      [variant]="variant()"
      [previewedItemId]="previewedItemId()"
      [cardSelection]="cardSelection()"
      [compactCard]="compactCard()"
      [debug]="debug"
      (open)="openSheetFolder.emit(item.data)"
      (openSheet)="openSheet.emit($event)"
      (appDblClick)="handleDoubleClickItem(item.data)"
      class="block"
      [class.bg-background-highlight]="item.section === STICKY_ITEM_SECTION && !isCard()"
      [class.stitch-hub-card-lifted]="item.section === STICKY_ITEM_SECTION && isCard()"
      [appSelectable]="item.data"
      [appSelectablePosition]="index"
      [appSelectableIdentifier]="item.data.id"
      [appSelectableListRef]="appSelectableList"
    />
  }
</div>

<app-list-selection-bar [list]="appSelectableList" />

<app-pagination2
    [page]="displayedPage"
    [loading]="loading"
    [pageSize]="pageSize"
    (refresh)="resetItems()"
    (pageChange)="loadPage($event, true)"
    [totalItems]="totalCount"
    class="border-t border-border" />
